// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3XA7E","errorLogs":"styles_errorLogs__LZ5r3"};